<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3"
import { UiButton, UiFormLayout, UiTextInput } from "@/components"
import { useNotifications } from "@/composables/useNotifications"

type MeasurementUnitPayload = {
  id?: number | null
  name: string
  symbol: string
}

const props = defineProps<{
  mode: "create" | "edit"
  title: string
  subtitle?: string
  measurementUnit: MeasurementUnitPayload
  errors?: Record<string, string[]>
}>()

const form = useForm({
  measurement_unit: {
    name: props.measurementUnit.name,
    symbol: props.measurementUnit.symbol,
  },
})

const notify = useNotifications()
const fieldError = (field: string) => props.errors?.[field]?.[0]

function submit() {
  const opts = { onSuccess: () => notify.success(props.mode === "create" ? "Unidade criada com sucesso" : "Unidade atualizada com sucesso") }
  if (props.mode === "create") {
    form.post("/measurement_units", opts)
    return
  }

  form.put(`/measurement_units/${props.measurementUnit.id}`, opts)
}
</script>

<template>
  <UiFormLayout :title="title" :subtitle="subtitle" back-href="/measurement_units" back-label="Voltar para unidades">
    <form class="space-y-4" @submit.prevent="submit">
      <div class="grid gap-4 md:grid-cols-2">
        <UiTextInput id="measurement-unit-name" v-model="form.measurement_unit.name" label="Nome" placeholder="Ex: Quilograma" :error="fieldError('name')" />
        <UiTextInput id="measurement-unit-symbol" v-model="form.measurement_unit.symbol" label="Sigla" placeholder="Ex: kg" :error="fieldError('symbol')" />
      </div>

      <div class="flex items-center gap-3 pt-2">
        <UiButton type="submit" :disabled="form.processing">
          {{ mode === "create" ? "Criar unidade" : "Salvar alteracoes" }}
        </UiButton>

        <Link
          href="/measurement_units"
          class="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
        >
          Cancelar
        </Link>
      </div>
    </form>
  </UiFormLayout>
</template>
